import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { BREAKPOINTS, STORAGE_NAMES, VIEW_TYPES } from '@root/app.config';
import { BlindData, BlindType, BlindTypes, GalleryViewTypes } from '@root/app.interfaces';
import { Router } from '@angular/router';
import { SessionStorageService } from '@core/services/session-storage/session-storage.service';
import { EngineService } from '@core/services/engine/engine.service';
import { ShareService } from '@core/services/share-data/share-data.service';
import { VariantService } from '@core/services/variant/variant.service';
import { filter, Subject, take, takeUntil } from 'rxjs';
import * as _ from 'lodash';
import { QuizService } from '@core/services/quiz/quiz.service';

@Component({
	selector: 'app-summary-blind-gallery',
	templateUrl: './summary-blind-gallery.component.html',
	styleUrls: ['./summary-blind-gallery.component.scss', './summary-blind-gallery.responsive.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class SummaryBlindGalleryComponent implements OnInit, OnDestroy {
	protected readonly IS_SHOP = this.variant.isShop();
	protected readonly BREAKPOINTS = BREAKPOINTS;
	protected readonly GALLERY_VIEW_TYPE = GalleryViewTypes;

	private destroy$ = new Subject<void>();

	protected hasBlindsData = false;
	protected blindsData: BlindData[] = [];
	protected filteredBlindsData: BlindData[] = [];
	protected selectedType: BlindType = BlindTypes.Outdoor;
	protected types: BlindType[];

	constructor(
		private router: Router,
		private variant: VariantService,
		private shareService: ShareService,
		private engineService: EngineService,
		private changeDetection: ChangeDetectorRef,
		private sessionStorageService: SessionStorageService,
		private quizService: QuizService,
	) {}

	ngOnInit(): void {
		this.getSessionStorageData();

		this.shareService.getScreenShotLoadedOnServer.pipe(takeUntil(this.destroy$)).subscribe(() => {
			this.getSessionStorageData();
		});
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
	}

	getSessionStorageData(): void {
		const storageData: BlindData[] = this.sessionStorageService.getBlindData(STORAGE_NAMES.zip_blind_data);

		if (!_.isEmpty(storageData)) {
			this.hasBlindsData = true;
			this.blindsData = storageData.filter((blind) => blind.has_name);

			this.getBlindsTypes();
		}

		this.changeDetection.markForCheck();
	}

	getBlindsTypes(): void {
		this.types = [...new Set(this.blindsData.map((blind) => blind.type))].sort().reverse() as BlindType[];

		this.onSelectFilter(this.types[0]);
	}

	onSelectFilter(type: BlindType): void {
		this.selectedType = type;

		this.filteredBlindsData = this.blindsData.filter((blind) => blind.type === this.selectedType);
	}

	onDeleteBlindConfirmation(): void {
		this.getSessionStorageData();
		this.handleEmptyBlindsState();
	}

	handleEmptyBlindsState(): void {
		this.hasBlindsData = !_.isEmpty(this.blindsData);
	}

	async onAddBlindItem(): Promise<void> {
		await this.router.navigateByUrl('home');
		this.shareService.getAccordionType.pipe(take(1)).subscribe(() => {
			this.shareService.setAddBlind(false);
		});
		if (this.sessionStorageService.getSession(STORAGE_NAMES.zip_view_type) === VIEW_TYPES.design) {
			this.shareService.getViewType
				.pipe(
					take(1),
					filter((type) => type === VIEW_TYPES.design),
				)
				.subscribe(() => {
					this.quizService.showQuizIfNeeded(VIEW_TYPES.design);
				});
		}
	}
}
